<template>
  <basic-container>
    <el-drawer
      
      :visible.sync="listFlag"
      :modal-append-to-body="false"
      size="70%"
      @close="closeAddSonDialog"
      append-to-body
    >
    <template slot="title">
      <span style="font-size:20px;font-weight:500;color:#333;">打印集</span>
    </template>
     <div style="width:100%;border-bottom:1px solid #333;text-align:right;padding-bottom:20px;">
          <el-button type="primary"
                     @click="deleteAll"> 移 除 全 部
          </el-button>
          <el-button type="primary"
                     @click="printAllQrcode"> 打 印 全 部
          </el-button>
          <el-button type="primary"
          style="margin-right:30px;"
                     @click="printCurrentQrcode"> 打 印 本 页
          </el-button>
     </div>
      <avue-crud :option="option"
                 :table-loading="loading"
                 :data="data"
                 :page.sync="page"
                 :permission="permissionList"
                 :before-open="beforeOpen"
                 v-model="form"
                 ref="crud"
                 @row-update="rowUpdate"
                 @row-save="rowSave"
                 @row-del="rowDel"
                 @search-change="searchChange"
                 @search-reset="searchReset"
                 @selection-change="selectionChange"
                 @current-change="currentChange"
                 @size-change="sizeChange"
                 @refresh-change="onLoad"
                 @on-load="onLoad">
<!--        <template slot="menuLeft">-->
<!--          <el-button type="danger"-->
<!--                     size="small"-->
<!--                     icon="el-icon-delete"-->
<!--                     plain-->
<!--                     v-if="permission.areaprintcollection_delete"-->
<!--                     @click="handleDelete">删 除-->
<!--          </el-button>-->
<!--        </template>-->
        <template slot="menuRight">
          
         
        </template>
        <template slot-scope="scope" slot="menu">
          <el-button
            type="text"
            size="small"
            icon="el-icon-delete"
            @click="removePrintCollection(scope.row)"
            style="color: #409EFF"
          >移出打印集
          </el-button>
        </template>
      </avue-crud>
      <qrcodeDownload
      ref="qrcodeDownload"
    ></qrcodeDownload>
    </el-drawer>
    
  </basic-container>
</template>

<script>
  import {
    add, 
    getDetail, 
    getList, 
    remove, 
    removeAll,
    update,
    getAllPrintQrcode,//获取打印集中所有二维码
    } from "@/api/crmedical/project/areaprintcollection";
  import {mapGetters} from "vuex";
import qrcodeDownload from '../device/device/qrcode-download';
  export default {
    components:{
      qrcodeDownload
    },
    data() {
      return {
        form: {},
        query: {},
        loading: true,
        listFlag: false,
        page: {
          pageSize: 10,
          currentPage: 1,
          total: 0
        },
        selectionList: [],
        tempProjectId:'',
        option: {
          refreshBtn:false,
          height: '400',
          calcHeight: 'auto',
          tip: false,
          border: true,
          index: true,
          viewBtn: true,
          selection: false,
          indexLabel: '序号',
          columnBtn: false,
          searchMenuSpan: 6,
          column: [
            {
              label: "区域全称",
              prop: "fullName",
              maxlength: 30,
              showWordLimit: true,
              search: false,
              overHidden: true,
              editDisplay: false,
              addDisplay: false,
            },
            {
              label: "区域名称",
              prop: "name",
              maxlength: 30,
              showWordLimit: true,
              overHidden: true,
              search: false,
            },
            {
              label: "区域编号",
              prop: "code",
              search: false,
              maxlength: 30,
              showWordLimit: true,
              overHidden: true,
            },
            {
              label: "节点属性",
              prop: "nodeType",
              type: 'select',
              disabled:true,
              search: false,
              dataType: 'number',
              dicUrl: 'api/blade-system/dict/dictionary?code=area_node_type',
              props: { label: 'dictValue', value: 'dictKey' },

            },
            {
              label: "科室",
              prop: "deptName",
              search: false,
              maxlength: 30,
              showWordLimit: true,
              overHidden: true,
            },
            {
              label: "区域类型",
              prop: "dataTypeName",
              search: false,
              maxlength: 30,
              showWordLimit: true,
              overHidden: true,
            },
            {
              label: "用途类型",
              prop: "userTypeName",
              search: false,
              maxlength: 30,
              showWordLimit: true,
              overHidden: true,
            },


          ]
        },
        data: []
      };
    },
    computed: {
      ...mapGetters(["permission"]),
      permissionList() {
        return {
          addBtn: this.vaildData(this.permission.areaprintcollection_add, false),
          viewBtn: this.vaildData(this.permission.areaprintcollection_view, false),
          delBtn: this.vaildData(this.permission.areaprintcollection_delete, false),
          editBtn: this.vaildData(this.permission.areaprintcollection_edit, false)
        };
      },
      ids() {
        let ids = [];
        this.selectionList.forEach(ele => {
          ids.push(ele.id);
        });
        return ids.join(",");
      }
    },
    methods: {
      // 打印全部二维码
      printAllQrcode(){
        getAllPrintQrcode({projectId:this.tempProjectId}).then(res=>{
          if(res.data.areaIdList.length<1){
            this.$message.warning("打印集无内容无法打印！");
            return;
          }
          let temArr = [];
          res.data.areaIdList.forEach(ele=>{
            temArr.push({id:ele})
          })

          this.$refs.qrcodeDownload.getQrcodes(this.tempProjectId,1,temArr);
          console.log(res)
        })
      },
       // 打印全部二维码
      printCurrentQrcode(){
        if(this.data.length<1){
            this.$message.warning("打印集无内容无法打印！");
            return;
        }
        let temArr = [];
        this.data.forEach(ele=>{
          temArr.push({id:ele.areaId})
        })
        this.$refs.qrcodeDownload.getQrcodes(this.tempProjectId,1,temArr);
      },
      rowSave(row, done, loading) {
        add(row).then(() => {
          this.onLoad();
          this.$message.success('操作成功!');
          done();
        }, error => {
          window.console.log(error);
          loading();
        });
      },
      rowUpdate(row, index, done, loading) {
        update(row).then(() => {
          this.onLoad();
          this.$message.success('操作成功!');
          done();
        }, error => {
          window.console.log(error);
          loading();
        });
      },
      rowDel(row) {
        this.$confirm("确定将选择数据删除?", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
          .then(() => {
            return remove({ids: row.id});
          })
          .then(() => {
            this.onLoad();
            this.$message.success('操作成功!');
          });
      },
      removePrintCollection(row){
        console.log(row);
        this.$confirm("确定将所选区域移除打印集?", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
          .then(() => {
            return remove({ids: row.id});
          })
          .then(() => {
            this.onLoad();
            this.$message.success('操作成功!');
          });
      },
      deleteAll(){
        this.$confirm("确定将所有区域移除打印集嘛?", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
          .then(() => {
            return removeAll({projectId: this.tempProjectId});
          })
          .then(() => {
            this.onLoad();
            this.$message.success('操作成功!');
          });
      },
      // handleDelete() {
      //   if (this.selectionList.length === 0) {
      //     this.$message.warning("请选择至少一条数据");
      //     return;
      //   }
      //   this.$confirm("确定将选择数据删除?", {
      //     confirmButtonText: "确定",
      //     cancelButtonText: "取消",
      //     type: "warning"
      //   })
      //     .then(() => {
      //       return remove({ids: this.ids});
      //     })
      //     .then(() => {
      //       this.onLoad();
      //       this.$message.success('操作成功!');
      //       this.$refs.crud.toggleSelection();
      //     });
      // },
      beforeOpen(done, type) {
        if (["edit", "view"].includes(type)) {
          getDetail({id: this.form.id}).then(({data}) => {
            this.form = data;
          });
        } else if ("add" === type) {
          this.cleanForm();
        }
        done();
      },
      cleanForm() {
        for (let key in this.form) {
          this.form[key] = null;
        }
      },
      searchReset() {
        this.query = {};
        this.onLoad();
      },
      searchChange(params, done) {
        this.query = params;
        this.page.currentPage = 1;
        this.onLoad();
        done();
      },
      selectionChange(list) {
        this.selectionList = list;
      },
      selectionClear() {
        this.selectionList = [];
        // this.$refs.crud.toggleSelection();
      },
      currentChange(currentPage) {
        this.page.currentPage = currentPage;
      },
      sizeChange(pageSize) {
        this.page.pageSize = pageSize;
      },
      openAreaPrintCollectionOnload(projectId) {
        console.log(1111111)
        this.listFlag = true;
        this.tempProjectId=projectId;
        this.onLoad();
      },
      onLoad(page) {
        page = page || this.page;
        this.loading = true;
        this.query.projectId = this.tempProjectId;
        getList(
          Object.assign({current: page.currentPage, size: page.pageSize}, this.query)
        ).then(({data}) => {
          this.page.total = data.total;
          this.data = data.records;
          this.loading = false;
          this.selectionClear();
        });
      }
    }
  };
</script>

<style>
</style>
